(function initYCUpsellV1() {
  const config = window.YCUpsellConfig || {};

  function enabled(value, fallback) {
    if (value === undefined || value === null || value === '') return fallback;
    return value === true || value === 'true' || value === 1 || value === '1';
  }

  function noopApi() {
    return {
      refresh: function () {},
      schedule: function () {},
    };
  }

  function removeShelves(selector) {
    document.querySelectorAll(selector).forEach(function (node) {
      node.remove();
    });
  }

  function trackUpsellAdd(source, response) {
    if (!window.dataLayer || typeof window.dataLayer.push !== 'function') return;
    try {
      window.dataLayer.push({
        event: 'yc_upsell_add',
        yc_upsell_source: source,
        cart_item_count: response?.item_count,
      });
    } catch (error) {}
  }

  const enableCartFreeShippingUpsellRoot = enabled(config.enableCartFreeShippingUpsell, true);
  const enableCartRewardProgressRoot = enabled(config.enableV2CartRewardProgress, true);
  const enableCartRewardGiftRoot = enabled(config.enableCartRewardAutoFreeGift, true);

  if (enableCartFreeShippingUpsellRoot || enableCartRewardProgressRoot || enableCartRewardGiftRoot) {
    (function initYcCartDrawerAddon() {
            const drawerContentSelector = '.cart-drawer__content';
            const shippingSlotSelector = '[data-bw-shipping-slot]';
            const addonSelector = '[data-yc-cart-addon]';
            const styleId = 'yc-cart-addon-styles';
            const thresholdCents = 6999;
            const minRemainingCents = 500;
            const maxRemainingCents = 3000;
            const addonCandidates = [
              {
                handle: 'rainforest-sound-diy-seed-craft-kit',
                label: 'DIY seed kit',
                note: 'Small rainforest seed pieces for making your own chime.',
              },
              {
                handle: 'forest-woodblock-natural-seed-percussion-instrument',
                label: 'Forest woodblock',
                note: 'A compact natural percussion accent.',
              },
              {
                handle: 'zen-bamboo-wind-chime-natural-wood-sound-garden-decor',
                label: 'Zen bamboo chime',
                note: 'A quiet wood-and-bamboo add-on.',
              },
              {
                handle: 'forest-chime-natural-seed-pod-bell-mobile',
                label: 'Forest seed chime',
                note: 'A small hanging seed bell for bags, windows, or desks.',
              },
              {
                handle: 'naptime-kitty-wooden-cat-charm',
                label: 'Naptime kitty charm',
                note: 'A carved wood charm with natural seed details.',
              },
              {
                handle: 'forest-rhythm-seed-shell-wrist-rattle',
                label: 'Forest rhythm bracelet',
                note: 'A wearable seed-shell rattle for movement and sound.',
              },
              {
                handle: 'lucky-gourd-ark-hanging-wind-chime',
                label: 'Lucky gourd chime',
                note: 'A small gourd-style chime with a natural tone.',
              },
              {
                handle: 'forest-bouquet-seed-cluster-keychain-bag-charm',
                label: 'Forest bouquet charm',
                note: 'A clustered seed charm for a bag or key ring.',
              },
              {
                handle: 'tribal-dancer-nut-shell-rattle-bracelet',
                label: 'Tribal dancer bracelet',
                note: 'A compact nut-shell rattle bracelet.',
              },
              {
                handle: 'fruit-bell-harp-vertical-seed-sound-sculpture',
                label: 'Fruit bell harp',
                note: 'A vertical seed sound piece for small spaces.',
              },
              {
                handle: 'deep-forest-chime-clustered-coconut-mobile',
                label: 'Deep forest chime',
                note: 'A clustered seed chime with a richer sound.',
              },
            ];

            const ritualSetCandidates = [
              {
                handle: 'handmade-pala-cardamom-seed-pod-wooden-handle-shaker-rainforest-rhythm',
                label: 'Pala seed pod shaker',
                note: 'Warm rainforest rhythm for the ritual set.',
                ritualKey: 'pala',
              },
              {
                handle: 'handmade-chacha-oleander-seed-pod-wooden-handle-shaker-rainforest-rhythm-instrument',
                label: 'Chacha seed pod shaker',
                note: 'A crisp companion tone for Pala and Juju.',
                ritualKey: 'chacha',
              },
              {
                handle: 'handmade-juju-seed-pod-wooden-handle-shaker-rainforest-natural-percussion',
                label: 'Juju seed pod shaker',
                note: 'A deeper forest accent for a complete trio.',
                ritualKey: 'juju',
              },
            ];

            const diyKitCandidates = [
              {
                handle: 'rainforest-sound-diy-seed-craft-kit',
                label: 'DIY seed kit',
                note: 'Seeds and natural pieces for building your own forest sound.',
              },
              {
                handle: 'forest-woodblock-natural-seed-percussion-instrument',
                label: 'Forest woodblock',
                note: 'A compact natural percussion accent for DIY play.',
              },
              {
                handle: 'woodland-whisper-sage-green-macrame-seed-bag-charm',
                label: 'Woodland macrame charm',
                note: 'Cord-wrapped seed detail for a handmade kit feel.',
              },
            ];

            const rewardProgressCandidates = [
              {
                handle: 'rainbow-seed-bag-charm-colorful-wrapped-keychain',
                label: 'Rainbow seed charm',
                note: 'A small charm idea for the gift milestone.',
              },
              {
                handle: 'forest-bell-nut-shell-tassel-bag-charm-green',
                label: 'Forest bell charm',
                note: 'A compact green seed tassel charm.',
              },
              {
                handle: 'forest-chime-natural-seed-pod-bell-mobile',
                label: 'Forest seed chime',
                note: 'A small hanging seed bell for bags or windows.',
              },
            ];

            const rewardThresholdCents = Number(config.cartRewardThresholdCents || 16999) || 16999;
            const enableCartFreeShippingUpsell = enabled(config.enableCartFreeShippingUpsell, true);
            const enableV15DiyKitBuilder = enabled(config.enableV15DiyKitBuilder, true);
            const enableV15RitualSetRecommendations = enabled(config.enableV15RitualSetRecommendations, true);
            const enableV2CartRewardProgress = enabled(config.enableV2CartRewardProgress, true);
            const enableCartRewardAutoFreeGift = enabled(config.enableCartRewardAutoFreeGift, true);
            const cartRewardGiftVariantId = Number(config.cartRewardGiftVariantId || 0);
            const enableV2KachingHandoff = enabled(config.enableV2KachingHandoff, false);
    
            const productCache = new Map();
            let observerStarted = false;
            let refreshScheduled = false;
            let refreshInFlight = null;
            let rewardGiftSyncInFlight = null;
            let rewardGiftEventSyncInFlight = false;
            let rewardGiftEventSyncScheduled = false;
            let rewardGiftEventSyncRequested = false;
            let pendingRewardGiftCart = null;
    
            function hasDrawerContext() {
              return Boolean(document.querySelector(drawerContentSelector));
            }

            function normalizeCurrencyCode(currency) {
              return String(currency || '').trim().toUpperCase();
            }

            function getShopifyCartMoneyFactor() {
              // Ajax cart monetary fields use a cents-style multiplier even for zero-decimal currencies.
              return 100;
            }

            function getCartCurrency(cart) {
              return normalizeCurrencyCode(cart?.currency || window.Shopify?.currency?.active || config.currency || 'USD') || 'USD';
            }

            function getActiveCurrencyRate(currency) {
              const normalized = normalizeCurrencyCode(currency);
              if (!normalized || normalized === 'USD') return 1;

              const shopifyCurrency = window.Shopify?.currency || {};
              const activeCurrency = normalizeCurrencyCode(shopifyCurrency.active || config.currency);
              const rate = Number(shopifyCurrency.rate || config.currencyRate || 0);

              if (activeCurrency === normalized && Number.isFinite(rate) && rate > 0) return rate;
              return 0;
            }

            function getRewardThresholdForCart(cart) {
              const currency = getCartCurrency(cart);
              if (currency === 'USD') return rewardThresholdCents;

              const rate = getActiveCurrencyRate(currency);
              if (!rate) return Number.POSITIVE_INFINITY;

              return Math.ceil(rewardThresholdCents * rate);
            }
    
            function ensureStyles() {
              if (document.getElementById(styleId)) return;
    
              const style = document.createElement('style');
              style.id = styleId;
              style.textContent = `
                .yc-cart-addon {
                  padding: 14px 20px 16px;
                  border-bottom: 1px solid rgba(95, 122, 97, 0.24);
                  background: #f1f5eb;
                  color: #324334;
                  box-sizing: border-box;
                }
    
                .yc-cart-addon[hidden] {
                  display: none !important;
                }
    
                .yc-cart-addon__header {
                  position: relative;
                  display: grid;
                  gap: 4px;
                  margin-bottom: 10px;
                  padding: 10px 12px 10px 14px;
                  border: 1px solid rgba(95, 122, 97, 0.28);
                  border-radius: 10px;
                  background: linear-gradient(180deg, rgba(195, 204, 166, 0.58) 0%, #f1f5eb 100%);
                }
    
                .yc-cart-addon__header::before {
                  content: '';
                  position: absolute;
                  left: 0;
                  top: 10px;
                  bottom: 10px;
                  width: 4px;
                  border-radius: 999px;
                  background: #5f7a61;
                }

                .yc-cart-addon__title {
                  margin: 0;
                  color: #324334;
                  font-size: 15px;
                  font-weight: 800;
                  line-height: 1.25;
                }

                .yc-cart-addon__note {
                  margin: 0;
                  color: #5f7a61;
                  font-size: 12.5px;
                  line-height: 1.38;
                }

                .yc-cart-addon__gap {
                  color: #324334;
                  font-weight: 800;
                }
    
                .yc-cart-addon__list {
                  display: grid;
                  gap: 8px;
                }
    
                .yc-cart-addon__card {
                  display: grid;
                  grid-template-columns: 52px minmax(0, 1fr) auto;
                  align-items: center;
                  gap: 10px;
                  padding: 8px;
                  border: 1px solid rgba(95, 122, 97, 0.24);
                  border-radius: 10px;
                  background: rgba(255, 255, 255, 0.72);
                }
    
                .yc-cart-addon__image {
                  width: 52px;
                  height: 52px;
                  border-radius: 8px;
                  object-fit: cover;
                  background: #c3cca6;
                }
    
                .yc-cart-addon__copy {
                  min-width: 0;
                }
    
                .yc-cart-addon__name {
                  display: block;
                  overflow: hidden;
                  color: #324334;
                  font-size: 12px;
                  font-weight: 700;
                  line-height: 1.25;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  text-decoration: none;
                }
    
                .yc-cart-addon__meta {
                  display: block;
                  margin-top: 3px;
                  color: #5f7a61;
                  font-size: 11px;
                  line-height: 1.25;
                }
    
                .yc-cart-addon__add {
                  min-width: 58px;
                  min-height: 34px;
                  padding: 0 11px;
                  border: 0;
                  border-radius: 999px;
                  background: #6c805f;
                  color: #fff;
                  cursor: pointer;
                  font-size: 12px;
                  font-weight: 700;
                  line-height: 1;
                }
    
                .yc-cart-addon__add[disabled] {
                  cursor: wait;
                  opacity: 0.7;
                }
              `;
    
              document.head.appendChild(style);
            }
    
            function escapeHtml(value) {
              return String(value || '')
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#39;');
            }
    
            function formatMoney(cents, cart) {
              const currency = getCartCurrency(cart);
              const amount = Number(cents || 0) / getShopifyCartMoneyFactor();
    
              try {
                return new Intl.NumberFormat(undefined, {
                  style: 'currency',
                  currency,
                }).format(amount);
              } catch (error) {
                return `$${amount.toFixed(2)}`;
              }
            }
    
            function removeAddonSlot() {
              document.querySelectorAll(addonSelector).forEach(function (node) {
                node.remove();
              });
            }
    
            function getDrawerContent() {
              const openDrawerContent = document.querySelector(`.cart-drawer__dialog[open] ${drawerContentSelector}`);
              if (openDrawerContent instanceof HTMLElement && openDrawerContent.querySelector(shippingSlotSelector)) {
                return openDrawerContent;
              }
    
              return Array.from(document.querySelectorAll(drawerContentSelector)).find(function (node) {
                return (
                  node instanceof HTMLElement &&
                  node.querySelector(shippingSlotSelector) &&
                  node.querySelector('.cart-drawer__items') &&
                  !node.closest('template')
                );
              });
            }
    
            function cleanupDuplicateAddonSlots(keeper) {
              document.querySelectorAll(addonSelector).forEach(function (node) {
                if (node !== keeper) node.remove();
              });
            }
    
            function ensureAddonSlot() {
              const drawerContent = getDrawerContent();
              if (!(drawerContent instanceof HTMLElement)) return null;
    
              const shippingSlot = drawerContent.querySelector(shippingSlotSelector);
              if (!(shippingSlot instanceof HTMLElement)) return null;
    
              ensureStyles();
    
              let slot = drawerContent.querySelector(addonSelector);
              if (!(slot instanceof HTMLElement)) {
                slot = document.createElement('div');
                slot.className = 'yc-cart-addon';
                slot.dataset.ycCartAddon = '';
              }
    
              if (shippingSlot.nextElementSibling !== slot) {
                shippingSlot.insertAdjacentElement('afterend', slot);
              }
    
              cleanupDuplicateAddonSlots(slot);
              return slot;
            }
    
            async function fetchAddonProduct(config) {
              if (productCache.has(config.handle)) return productCache.get(config.handle);
    
              const promise = fetch(`/products/${config.handle}.js`, { credentials: 'same-origin' })
                .then(function (response) {
                  if (!response.ok) throw new Error(`Product fetch failed: ${config.handle}`);
                  return response.json();
                })
                .then(function (product) {
                  const variants = Array.isArray(product.variants)
                    ? product.variants
                        .filter(function (variant) {
                          return variant && variant.available && Number(variant.price) > 0;
                        })
                        .map(function (variant) {
                          return {
                            id: variant.id,
                            priceCents: Number(variant.price),
                          };
                        })
                        .sort(function (a, b) {
                          return a.priceCents - b.priceCents;
                        })
                    : [];
    
                  if (!variants.length) return null;
    
                  return {
                    handle: config.handle,
                    label: config.label || product.title,
                    note: config.note || '',
                    title: product.title || config.label,
                    url: product.url || `/products/${config.handle}`,
                    image: product.featured_image || '',
                    variants,
                  };
                })
                .catch(function () {
                  return null;
                });
    
              productCache.set(config.handle, promise);
              return promise;
            }
    
            async function getVisibleProducts(cart, remainingCents) {
              const cartHandles = new Set(
                (cart?.items || []).map(function (item) {
                  return item.handle;
                })
              );
    
              const products = await Promise.all(addonCandidates.map(fetchAddonProduct));
    
              return products
                .filter(Boolean)
                .filter(function (product) {
                  return !cartHandles.has(product.handle);
                })
                .map(function (product) {
                  const variant = product.variants.find(function (item) {
                    return item.priceCents >= remainingCents;
                  });
    
                  if (!variant) return null;
    
                  return {
                    ...product,
                    variantId: variant.id,
                    priceCents: variant.priceCents,
                  };
                })
                .filter(Boolean)
                .sort(function (a, b) {
                  return a.priceCents - b.priceCents;
                })
                .slice(0, 3);
            }
    
            function getCartHandles(cart) {
              return new Set(
                (cart?.items || []).map(function (item) {
                  return item.handle;
                }).filter(Boolean)
              );
            }

            function selectCheapestVariant(product) {
              const variants = Array.isArray(product?.variants) ? product.variants : [];
              return variants.slice().sort(function (a, b) {
                return a.priceCents - b.priceCents;
              })[0];
            }

            async function getRecommendationProducts(candidates, cart, limit) {
              const cartHandles = getCartHandles(cart);
              const products = await Promise.all(candidates.map(fetchAddonProduct));
              return products
                .filter(Boolean)
                .filter(function (product) {
                  return !cartHandles.has(product.handle);
                })
                .map(function (product) {
                  const variant = selectCheapestVariant(product);
                  if (!variant) return null;
                  return {
                    ...product,
                    variantId: variant.id,
                    priceCents: variant.priceCents,
                  };
                })
                .filter(Boolean)
                .sort(function (a, b) {
                  return a.priceCents - b.priceCents;
                })
                .slice(0, limit || 3);
            }

            async function getRitualSetProducts(cart) {
              const cartHandles = getCartHandles(cart);
              const hasRitualBase = ritualSetCandidates.some(function (item) {
                return cartHandles.has(item.handle);
              });
              if (!hasRitualBase) return [];
              return getRecommendationProducts(ritualSetCandidates, cart, 3);
            }

            function renderAddon(slot, products, cart, remainingCents, context) {
              if (!(slot instanceof HTMLElement) || !products.length) {
                removeAddonSlot();
                return;
              }
    
              const remainingLabel = Number(remainingCents || 0) > 0 ? formatMoney(remainingCents, cart) : '';
              const title = context?.title || 'Add one forest piece to unlock free shipping';
              const note = context?.note || `You are <strong class="yc-cart-addon__gap">${escapeHtml(remainingLabel)}</strong> away. Add one small natural piece to unlock it now.`;
              const source = context?.source || 'cart_free_shipping';
    
              slot.hidden = false;
              slot.innerHTML = `
                <div class="yc-cart-addon__header">
                  <p class="yc-cart-addon__title">${escapeHtml(title)}</p>
                  <p class="yc-cart-addon__note">${note}</p>
                </div>
                <div class="yc-cart-addon__list">
                  ${products
                    .map(function (product) {
                      const imageMarkup = product.image
                        ? `<img class="yc-cart-addon__image" src="${escapeHtml(product.image)}" alt="${escapeHtml(product.title)}" loading="lazy">`
                        : '<div class="yc-cart-addon__image" aria-hidden="true"></div>';
    
                      return `
                        <article class="yc-cart-addon__card">
                          <a href="${escapeHtml(product.url)}" tabindex="-1" aria-hidden="true">${imageMarkup}</a>
                          <span class="yc-cart-addon__copy">
                            <a class="yc-cart-addon__name" href="${escapeHtml(product.url)}">${escapeHtml(product.label)}</a>
                            <span class="yc-cart-addon__meta">${escapeHtml(formatMoney(product.priceCents, cart))} · ${escapeHtml(product.note)}</span>
                          </span>
                          <button class="yc-cart-addon__add" type="button" data-yc-cart-addon-add data-yc-upsell-source="${escapeHtml(source)}" data-variant-id="${product.variantId}">Add</button>
                        </article>
                      `;
                    })
                    .join('')}
                </div>
              `;
    
              bindAddonButtons(slot);
            }
    
            function getCartSectionIds() {
              return Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
                .map(function (node) {
                  return node.dataset.sectionId;
                })
                .filter(Boolean);
            }

            function dispatchRewardGiftCartUpdate(response, itemCount) {
              document.dispatchEvent(
                new CustomEvent('cart:update', {
                  bubbles: true,
                  detail: {
                    resource: response,
                    sourceId: 'yc-cart-reward-gift',
                    data: {
                      source: 'yc-cart-reward-gift',
                      sections: response?.sections,
                      itemCount,
                    },
                  },
                })
              );
              window.BWShippingBar?.schedule?.();
            }

            function isRewardGiftItem(item) {
              const properties = item?.properties || {};
              return (
                Number(item?.id || 0) === cartRewardGiftVariantId ||
                properties._yc_reward_gift === String(rewardThresholdCents) ||
                properties._yc_upsell_source === 'cart_reward_gift'
              );
            }

            async function requestCartMutation(path, body) {
              return fetch(path, {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                  'Content-Type': 'application/json',
                  Accept: 'application/json',
                },
                body: JSON.stringify(body),
              }).then(function (response) {
                // Non-JSON error pages (429 / Cloudflare) must still surface as a failed mutation.
            if (!response.ok) {
              return response.json().catch(function () {
                return {};
              }).then(function (payload) {
                return Object.assign({}, payload, { status: payload?.status || response.status });
              });
            }
            return response.json();
              });
            }

            async function getLatestCart() {
              return fetch('/cart.js', { credentials: 'same-origin' }).then(function (response) {
                return response.json();
              });
            }

            function isCartPayload(payload) {
              return Boolean(
                payload &&
                  typeof payload === 'object' &&
                  Array.isArray(payload.items) &&
                  Object.prototype.hasOwnProperty.call(payload, 'total_price')
              );
            }

            function extractCartFromEvent(event) {
              const detail = event?.detail || {};
              const candidates = [
                detail.resource,
                detail.cart,
                detail.data?.cart,
                detail.data?.resource,
              ];

              return candidates.find(isCartPayload) || null;
            }

            function isRewardGiftAddBlocked() {
              try {
                const raw = window.sessionStorage?.getItem('yc-reward-gift-add-blocked');
                if (!raw) return false;
                const state = JSON.parse(raw);
                return state.variantId === cartRewardGiftVariantId && state.until > Date.now();
              } catch (error) {
                return false;
              }
            }

            // A failed gift add (unpublished gift, rate limit) is retried at most once per 30 minutes per session.
            function blockRewardGiftAdd(status) {
              try {
                window.sessionStorage?.setItem(
                  'yc-reward-gift-add-blocked',
                  JSON.stringify({ variantId: cartRewardGiftVariantId, status, until: Date.now() + 30 * 60 * 1000 })
                );
              } catch (error) {}
            }

            async function syncRewardGift(cart) {
              if (
                !enableV2CartRewardProgress ||
                !enableCartRewardAutoFreeGift ||
                enableV2KachingHandoff ||
                !cartRewardGiftVariantId
              ) {
                return cart;
              }

              if (rewardGiftSyncInFlight) return rewardGiftSyncInFlight;

	              rewardGiftSyncInFlight = (async function () {
	                const items = Array.isArray(cart?.items) ? cart.items : [];
	                const giftItems = items.filter(isRewardGiftItem);
	                const rewardThresholdForCart = getRewardThresholdForCart(cart);
	                const qualifies = Number(cart?.total_price || 0) >= rewardThresholdForCart;
	                const sectionIds = getCartSectionIds();
                const sections = sectionIds.join(',');
                const sectionsUrl = window.location.pathname;

                try {
                  if (qualifies && !giftItems.length && !isRewardGiftAddBlocked()) {
                    const response = await requestCartMutation(window.Theme?.routes?.cart_add_url || '/cart/add.js', {
                      items: [
                        {
                          id: cartRewardGiftVariantId,
                          quantity: 1,
                          properties: {
                            _yc_upsell_source: 'cart_reward_gift',
                            _yc_reward_gift: String(rewardThresholdCents),
                            _yc_reward_label: 'Free Small Gift (US$19.99+ Value)',
                            _yc_reward_value: 'US$19.99+',
                          },
                        },
                      ],
                      sections,
                      sections_url: sectionsUrl,
                    });

                    if (!response.status) {
                      dispatchRewardGiftCartUpdate(response, 1);
                      return getLatestCart();
                    }
                    blockRewardGiftAdd(response.status);
                  }

                  if (!qualifies && giftItems.length) {
                    for (const item of giftItems) {
                      const response = await requestCartMutation(window.Theme?.routes?.cart_change_url || '/cart/change.js', {
                        id: item.key,
                        quantity: 0,
                        sections,
                        sections_url: sectionsUrl,
                      });
                      if (!response.status) dispatchRewardGiftCartUpdate(response, -Number(item.quantity || 1));
                    }

                    return getLatestCart();
                  }

                  if (qualifies && giftItems.length) {
                    const extraGiftItems = giftItems.slice(1);
                    for (const item of extraGiftItems) {
                      const response = await requestCartMutation(window.Theme?.routes?.cart_change_url || '/cart/change.js', {
                        id: item.key,
                        quantity: 0,
                        sections,
                        sections_url: sectionsUrl,
                      });
                      if (!response.status) dispatchRewardGiftCartUpdate(response, -Number(item.quantity || 1));
                    }

                    const firstGift = giftItems[0];
                    if (Number(firstGift.quantity || 0) !== 1) {
                      const response = await requestCartMutation(window.Theme?.routes?.cart_change_url || '/cart/change.js', {
                        id: firstGift.key,
                        quantity: 1,
                        sections,
                        sections_url: sectionsUrl,
                      });
                      if (!response.status) dispatchRewardGiftCartUpdate(response, 1 - Number(firstGift.quantity || 0));
                    }

                    if (extraGiftItems.length || Number(firstGift.quantity || 0) !== 1) return getLatestCart();
                  }
                } catch (error) {}

                return cart;
              })();

              try {
                return await rewardGiftSyncInFlight;
              } finally {
                rewardGiftSyncInFlight = null;
              }
            }

            function queueRewardGiftSync(cart) {
              if (isCartPayload(cart)) pendingRewardGiftCart = cart;
              rewardGiftEventSyncRequested = true;

              if (rewardGiftEventSyncInFlight || rewardGiftEventSyncScheduled) return;

              rewardGiftEventSyncScheduled = true;
              window.setTimeout(async function () {
                rewardGiftEventSyncScheduled = false;
                rewardGiftEventSyncInFlight = true;

                try {
                  while (rewardGiftEventSyncRequested) {
                    rewardGiftEventSyncRequested = false;
                    const cartToSync = pendingRewardGiftCart;
                    pendingRewardGiftCart = null;
                    await syncRewardGift(cartToSync || (await getLatestCart()));
                  }
                } catch (error) {
                } finally {
                  rewardGiftEventSyncInFlight = false;
                }
              }, 100);
            }

            function startRewardGiftEventSync() {
              if (window.__ycRewardGiftEventSyncReady) return;
              window.__ycRewardGiftEventSyncReady = true;

              document.addEventListener('cart:update', function (event) {
                if (event?.detail?.sourceId === 'yc-cart-reward-gift') return;
                queueRewardGiftSync(extractCartFromEvent(event));
              });
              document.addEventListener('cart:change', function () {
                queueRewardGiftSync();
              });
              document.addEventListener('cart:updated', function () {
                queueRewardGiftSync();
              });
              document.addEventListener('cart:refresh', function () {
                queueRewardGiftSync();
              });
              window.addEventListener('pageshow', function () {
                queueRewardGiftSync();
              });
            }
    
            async function addVariantToCart(button) {
              const variantId = button?.dataset?.variantId;
              const source = button?.dataset?.ycUpsellSource || 'cart_free_shipping';
              if (!variantId) return;
    
              const originalText = button.textContent;
              button.disabled = true;
              button.textContent = 'Adding';
    
              try {
                const sectionIds = getCartSectionIds();
                const endpoint = window.Theme?.routes?.cart_add_url || '/cart/add.js';
                const response = await fetch(endpoint, {
                  method: 'POST',
                  credentials: 'same-origin',
                  headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                  },
                  body: JSON.stringify({
                    items: [{ id: Number(variantId), quantity: 1, properties: { _yc_upsell_source: source } }],
                    sections: sectionIds.join(','),
                    sections_url: window.location.pathname,
                  }),
                }).then(function (fetchResponse) {
                  return fetchResponse.json();
                });
    
                if (response.status) {
                  throw new Error(response.description || response.message || 'Unable to add');
                }
    
                document.dispatchEvent(
                  new CustomEvent('cart:update', {
                    bubbles: true,
                    detail: {
                      resource: response,
                      sourceId: 'yc-cart-addon',
                      data: {
                        source: 'yc-cart-addon',
                        sections: response.sections,
                        itemCount: 1,
                      },
                    },
                  })
                );
    
                trackUpsellAdd(source, response);
                window.BWShippingBar?.schedule?.();
                scheduleRefresh();
              } catch (error) {
                button.textContent = 'Try again';
                window.setTimeout(function () {
                  button.textContent = originalText;
                  button.disabled = false;
                }, 1800);
                return;
              }
    
              button.textContent = 'Added';
              window.setTimeout(function () {
                button.disabled = false;
                button.textContent = originalText;
              }, 1200);
            }
    
            function bindAddonButtons(root) {
              root.querySelectorAll('[data-yc-cart-addon-add]').forEach(function (button) {
                if (!(button instanceof HTMLButtonElement) || button.dataset.ycCartAddonBound === '1') return;
                button.dataset.ycCartAddonBound = '1';
                button.addEventListener('click', function () {
                  addVariantToCart(button);
                });
              });
            }
    
            async function refreshAddon() {
              if (!hasDrawerContext()) return;
              if (refreshInFlight) return refreshInFlight;
    
              refreshInFlight = (async function () {
                try {
                  let cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(function (response) {
                    return response.json();
                  });
                  cart = await syncRewardGift(cart);
    
                  const total = Number(cart?.total_price || 0);
                  const remainingCents = thresholdCents - total;

                  if (!enableCartFreeShippingUpsell) {
                    removeAddonSlot();
                    return;
                  }
    
                  if (Number(cart?.item_count || 0) === 0) {
                    removeAddonSlot();
                    return;
                  }
    
                  const slot = ensureAddonSlot();
                  if (!(slot instanceof HTMLElement)) return;
    
                  if (remainingCents >= minRemainingCents && remainingCents <= maxRemainingCents) {
                    const products = await getVisibleProducts(cart, remainingCents);
                    renderAddon(slot, products, cart, remainingCents, {
                      source: 'cart_free_shipping',
                      title: 'Add one forest piece to unlock free shipping',
                    });
                    return;
                  }

                  if (!enableV2KachingHandoff && enableV15RitualSetRecommendations) {
                    const ritualProducts = await getRitualSetProducts(cart);
                    if (ritualProducts.length) {
                      renderAddon(slot, ritualProducts, cart, 0, {
                        source: 'ritual_set',
                        title: 'Complete your rainforest ritual set',
                        note: 'Pair Pala, Chacha, and Juju for a fuller natural sound ritual.',
                      });
                      return;
                    }
                  }

                  if (!enableV2KachingHandoff && enableV15DiyKitBuilder) {
                    const diyProducts = await getRecommendationProducts(diyKitCandidates, cart, 3);
                    if (diyProducts.length) {
                      renderAddon(slot, diyProducts, cart, 0, {
                        source: 'diy_kit_builder',
                        title: 'Build a small DIY forest sound kit',
                        note: 'Add seeds, corded charms, or compact sound pieces to create a hands-on forest set.',
                      });
                      return;
                    }
                  }

	                  const rewardThresholdForCart = getRewardThresholdForCart(cart);
	                  if (!enableV2KachingHandoff && enableV2CartRewardProgress && Number.isFinite(rewardThresholdForCart) && total < rewardThresholdForCart) {
	                    const rewardProducts = await getRecommendationProducts(rewardProgressCandidates, cart, 3);
	                    if (rewardProducts.length) {
	                      renderAddon(slot, rewardProducts, cart, rewardThresholdForCart - total, {
	                        source: 'cart_reward_progress',
	                        title: 'Keep going toward the small gift milestone',
	                        note: `You are <strong class="yc-cart-addon__gap">${escapeHtml(formatMoney(rewardThresholdForCart - total, cart))}</strong> away from the US$169.99 small gift milestone.`,
	                      });
                      return;
                    }
                  }

                  removeAddonSlot();
                } catch (error) {
                  removeAddonSlot();
                } finally {
                  refreshInFlight = null;
                }
              })();
    
              return refreshInFlight;
            }
    
            function scheduleRefresh() {
              if (!hasDrawerContext()) return;
              if (refreshScheduled) return;
              refreshScheduled = true;
              window.setTimeout(function () {
                const refreshPromise = refreshAddon();
                if (!refreshPromise || typeof refreshPromise.finally !== 'function') {
                  refreshScheduled = false;
                  return;
                }
    
                refreshPromise.finally(function () {
                  refreshScheduled = false;
                });
              }, 160);
            }
    
            function scheduleRefreshAfterCartAction() {
              window.setTimeout(scheduleRefresh, 360);
              window.setTimeout(scheduleRefresh, 1250);
            }
    
            function isCartActionTarget(target) {
              if (!(target instanceof Element)) return false;
    
              const control = target.closest('button, a, summary');
              const controlText = `${control?.getAttribute('aria-label') || ''} ${control?.textContent || ''}`.toLowerCase();
    
              return Boolean(
                target.closest('[data-testid="standalone-add-to-cart"]') ||
                  target.closest('button[name="add"]') ||
                  target.closest('[data-yc-pdp-addon-add]') ||
                  target.closest('[data-yc-sound-pairing-add]') ||
                  target.closest('.cart-drawer__dialog') ||
                  /\bcart\b|add to cart|increase quantity|decrease quantity|remove/.test(controlText)
              );
            }
    
            function startCartActionRefresh() {
              document.addEventListener(
                'click',
                function (event) {
                  if (isCartActionTarget(event.target)) scheduleRefreshAfterCartAction();
                },
                true
              );
    
              document.addEventListener('change', function (event) {
                if (event.target instanceof Element && event.target.closest('.cart-drawer__dialog')) {
                  scheduleRefreshAfterCartAction();
                }
              });
            }
    
            function startObserver() {
              if (observerStarted || !(document.body instanceof HTMLElement)) return;
              observerStarted = true;
    
              const observer = new MutationObserver(function (mutations) {
                const shouldRefresh = mutations.some(function (mutation) {
                  return Array.from(mutation.addedNodes).some(function (node) {
                    return (
                      node instanceof HTMLElement &&
                      (node.matches(drawerContentSelector) ||
                        node.matches(shippingSlotSelector) ||
                        node.querySelector(drawerContentSelector) ||
                        node.querySelector(shippingSlotSelector))
                    );
                  });
                });
    
                if (shouldRefresh) scheduleRefresh();
              });
    
              observer.observe(document.body, { childList: true, subtree: true });
              window.setTimeout(function () {
                observer.disconnect();
              }, 14000);
            }
    
            const api = {
              refresh: refreshAddon,
              schedule: scheduleRefresh,
            };
    
            window.YCCartAddon = api;
    
            document.addEventListener('cart:update', scheduleRefresh);
            document.addEventListener('cart:error', scheduleRefresh);
            document.addEventListener('cart:change', scheduleRefreshAfterCartAction);
            document.addEventListener('cart:updated', scheduleRefreshAfterCartAction);
            document.addEventListener('cart:refresh', scheduleRefreshAfterCartAction);
            window.addEventListener('pageshow', scheduleRefresh);
    
            function startWhenReady() {
              startRewardGiftEventSync();
              startObserver();
              startCartActionRefresh();
              scheduleRefresh();
            }
    
            if (document.readyState === 'loading') {
              document.addEventListener('DOMContentLoaded', startWhenReady, { once: true });
            } else {
              startWhenReady();
            }
          })();
  } else {
    window.YCCartAddon = noopApi();
    removeShelves('[data-yc-cart-addon]');
  }

  if (enabled(config.enablePdpUpsell, false) && enabled(config.enablePdpFreeShippingUpsell, false)) {
    (function initYcPdpAddonShelf() {
            const mainNode = document.querySelector('main[data-template]');
            const templateName = mainNode?.dataset?.template || '';
            if (!templateName.includes('product')) return;
    
            const thresholdCents = 6999;
            const shelfSelector = '[data-yc-pdp-addon-shelf]';
            const styleId = 'yc-pdp-addon-shelf-styles';
            const addToCartSelector = '[data-testid="standalone-add-to-cart"]';
            const addonCandidates = [
              {
                handle: 'rainforest-sound-diy-seed-craft-kit',
                label: 'DIY seed kit',
                note: 'Natural seed pieces for making your own chime.',
              },
              {
                handle: 'forest-woodblock-natural-seed-percussion-instrument',
                label: 'Forest woodblock',
                note: 'Compact natural percussion accent.',
              },
              {
                handle: 'morning-dew-crystal-bead-natural-seed-drop-earrings',
                label: 'Seed earrings',
                note: 'Light natural seed earrings with crystal shimmer.',
              },
              {
                handle: 'rainbow-seed-bag-charm-colorful-wrapped-keychain',
                label: 'Rainbow seed charm',
                note: 'Colorful seed charm for keys or bags.',
              },
              {
                handle: 'forest-bell-nut-shell-tassel-bag-charm-green',
                label: 'Forest bell charm',
                note: 'Small seed tassel charm with a soft natural look.',
              },
              {
                handle: 'naptime-kitty-wooden-cat-charm',
                label: 'Naptime kitty charm',
                note: 'Wood cat charm with natural seed details.',
              },
              {
                handle: 'forest-bouquet-seed-cluster-keychain-bag-charm',
                label: 'Forest bouquet charm',
                note: 'Clustered seed charm for a bag or key ring.',
              },
              {
                handle: 'forest-harmony-green-bead-natural-seed-zen-earrings',
                label: 'Forest seed earrings',
                note: 'Zen-style green bead and natural seed earrings.',
              },
              {
                handle: 'crystal-harmony-tassel-charm-natural-seeds',
                label: 'Crystal harmony charm',
                note: 'Seed tassel charm with a clear crystal accent.',
              },
            ];
    
            const productCache = new Map();
            let currentProductPromise = null;
            let refreshInFlight = null;
            let refreshScheduled = false;
    
            function getProductHandle() {
              const match = window.location.pathname.match(/\/products\/([^/?#]+)/);
              return match ? decodeURIComponent(match[1]) : '';
            }
    
            function getProductForm() {
              const addButton = document.querySelector(`.product-details ${addToCartSelector}`);
              const buttonForm = addButton?.closest('form');
              if (buttonForm instanceof HTMLFormElement) return buttonForm;
    
              const form = document.querySelector(
                '.product-details product-form-component:not(.quick-add__product-form-component) form[data-type="add-to-cart-form"]'
              );
              return form instanceof HTMLFormElement ? form : null;
            }
    
            function getCurrentQuantity() {
              const form = getProductForm();
              const input = form?.querySelector('input[name="quantity"], quantity-selector-component input');
              const value = Number(input?.value || 1);
              return Number.isFinite(value) && value > 0 ? Math.max(1, Math.floor(value)) : 1;
            }
    
            function ensureStyles() {
              if (document.getElementById(styleId)) return;
    
              const style = document.createElement('style');
              style.id = styleId;
              style.textContent = `
                .yc-pdp-addon-shelf {
                  margin: 12px 0 14px;
                  padding: 12px;
                  border: 1px solid rgba(85, 101, 75, 0.18);
                  border-radius: 10px;
                  background: #fbfaf6;
                  color: #3f4b39;
                  box-sizing: border-box;
                  box-shadow: 0 10px 24px rgba(40, 52, 36, 0.08);
                }
    
                .yc-pdp-addon-shelf[hidden] {
                  display: none !important;
                }
    
                .yc-pdp-addon-shelf__header {
                  position: relative;
                  display: grid;
                  gap: 4px;
                  margin: 0 0 12px;
                  padding: 10px 12px 10px 14px;
                  border: 1px solid rgba(85, 101, 75, 0.16);
                  border-radius: 9px;
                  background: linear-gradient(180deg, #f0f4e8 0%, #fbfaf6 100%);
                }
    
                .yc-pdp-addon-shelf__header::before {
                  content: '';
                  position: absolute;
                  left: 0;
                  top: 10px;
                  bottom: 10px;
                  width: 4px;
                  border-radius: 999px;
                  background: #55654b;
                }
    
                .yc-pdp-addon-shelf__title {
                  margin: 0;
                  color: #3f4b39;
                  font-size: 15px;
                  font-weight: 800;
                  line-height: 1.24;
                }
    
                .yc-pdp-addon-shelf__note {
                  margin: 0;
                  color: #66745f;
                  font-size: 12.5px;
                  line-height: 1.35;
                }
    
                .yc-pdp-addon-shelf__gap {
                  color: #384333;
                  font-weight: 800;
                }
    
                .yc-pdp-addon-shelf__list {
                  display: grid;
                  grid-template-columns: repeat(3, minmax(0, 1fr));
                  align-items: stretch;
                  gap: 8px;
                }
    
                .yc-pdp-addon-shelf__card {
                  display: grid;
                  grid-template-columns: 1fr;
                  grid-template-rows: auto 1fr auto;
                  align-items: start;
                  gap: 8px;
                  min-width: 0;
                  min-height: 100%;
                  padding: 8px;
                  border: 1px solid rgba(72, 86, 64, 0.14);
                  border-radius: 8px;
                  background: #fff;
                }
    
                .yc-pdp-addon-shelf__image {
                  width: 100%;
                  height: auto;
                  aspect-ratio: 4 / 3;
                  border-radius: 7px;
                  object-fit: cover;
                  background: #eef0e8;
                }
    
                .yc-pdp-addon-shelf__copy {
                  display: grid;
                  gap: 3px;
                  min-width: 0;
                }
    
                .yc-pdp-addon-shelf__name {
                  display: -webkit-box;
                  overflow: hidden;
                  color: #384333;
                  font-size: 12px;
                  font-weight: 700;
                  line-height: 1.25;
                  text-overflow: ellipsis;
                  white-space: normal;
                  text-decoration: none;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 2;
                }
    
                .yc-pdp-addon-shelf__meta {
                  display: -webkit-box;
                  overflow: hidden;
                  margin-top: 0;
                  color: #697761;
                  font-size: 11px;
                  line-height: 1.25;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 3;
                }
    
                .yc-pdp-addon-shelf__add {
                  width: 100%;
                  min-height: 34px;
                  padding: 0 10px;
                  border: 0;
                  border-radius: 999px;
                  background: #55654b;
                  color: #fff;
                  cursor: pointer;
                  font-size: 12px;
                  font-weight: 700;
                  line-height: 1;
                }
    
                .yc-pdp-addon-shelf__add[disabled] {
                  cursor: wait;
                  opacity: 0.7;
                }
    
                @media screen and (max-width: 749px) {
                  .yc-pdp-addon-shelf {
                    padding: 11px;
                  }
    
                  .yc-pdp-addon-shelf__list {
                    display: flex;
                    gap: 8px;
                    overflow-x: auto;
                    padding-bottom: 2px;
                    scroll-snap-type: x proximity;
                    -webkit-overflow-scrolling: touch;
                  }
    
                  .yc-pdp-addon-shelf__card {
                    flex: 0 0 min(76vw, 250px);
                    scroll-snap-align: start;
                  }
                }
              `;
    
              document.head.appendChild(style);
            }
    
            function escapeHtml(value) {
              return String(value || '')
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#39;');
            }
    
            function formatMoney(cents, currency) {
              const amount = Number(cents || 0) / 100;
    
              try {
                return new Intl.NumberFormat(undefined, {
                  style: 'currency',
                  currency: currency || window.Shopify?.currency?.active || 'USD',
                }).format(amount);
              } catch (error) {
                return `$${amount.toFixed(2)}`;
              }
            }
    
            function cleanupDuplicateShelves(keeper) {
              document.querySelectorAll(shelfSelector).forEach(function (node) {
                if (node !== keeper) node.remove();
              });
            }
    
            function removeShelf() {
              document.querySelectorAll(shelfSelector).forEach(function (node) {
                node.remove();
              });
            }
    
            function ensureShelf() {
              const form = getProductForm();
              if (!(form instanceof HTMLFormElement)) return null;
    
              ensureStyles();
    
              let shelf = document.querySelector(shelfSelector);
              if (!(shelf instanceof HTMLElement)) {
                shelf = document.createElement('section');
                shelf.className = 'yc-pdp-addon-shelf';
                shelf.dataset.ycPdpAddonShelf = '';
                shelf.setAttribute('aria-label', 'Free shipping add-ons');
              }
    
              if (form.nextElementSibling !== shelf) {
                form.insertAdjacentElement('afterend', shelf);
              }
    
              cleanupDuplicateShelves(shelf);
              return shelf;
            }
    
            async function fetchProduct(handle) {
              if (!handle) return null;
              if (productCache.has(handle)) return productCache.get(handle);
    
              const promise = fetch(`/products/${handle}.js`, { credentials: 'same-origin' })
                .then(function (response) {
                  if (!response.ok) throw new Error(`Product fetch failed: ${handle}`);
                  return response.json();
                })
                .then(function (product) {
                  const variants = Array.isArray(product.variants)
                    ? product.variants
                        .filter(function (variant) {
                          return variant && variant.available && Number(variant.price) > 0;
                        })
                        .map(function (variant) {
                          return {
                            id: Number(variant.id),
                            priceCents: Number(variant.price),
                          };
                        })
                        .sort(function (a, b) {
                          return a.priceCents - b.priceCents;
                        })
                    : [];
    
                  if (!variants.length) return null;
    
                  return {
                    handle,
                    title: product.title || handle,
                    url: product.url || `/products/${handle}`,
                    image: product.featured_image || '',
                    currency: product.currency || window.Shopify?.currency?.active || 'USD',
                    variants,
                  };
                })
                .catch(function () {
                  return null;
                });
    
              productCache.set(handle, promise);
              return promise;
            }
    
            function getCurrentProduct() {
              if (!currentProductPromise) {
                currentProductPromise = fetchProduct(getProductHandle());
              }
              return currentProductPromise;
            }
    
            function getCurrentVariant(product) {
              const form = getProductForm();
              const formVariantId = Number(form?.querySelector('[name="id"]')?.value || 0);
              const urlVariantId = Number(new URLSearchParams(window.location.search).get('variant') || 0);
              const selectedId = formVariantId || urlVariantId;
    
              return (
                product?.variants?.find(function (variant) {
                  return variant.id === selectedId;
                }) ||
                product?.variants?.[0] ||
                null
              );
            }
    
            async function getVisibleProducts(currentHandle, remainingCents) {
              const products = await Promise.all(addonCandidates.map(function (config) {
                return fetchProduct(config.handle).then(function (product) {
                  if (!product || product.handle === currentHandle) return null;
                  const variant = product.variants.find(function (item) {
                    return item.priceCents >= remainingCents;
                  });
                  if (!variant) return null;
    
                  return {
                    ...product,
                    label: config.label || product.title,
                    note: config.note || '',
                    addonVariantId: variant.id,
                    priceCents: variant.priceCents,
                  };
                });
              }));
    
              return products
                .filter(Boolean)
                .sort(function (a, b) {
                  return a.priceCents - b.priceCents;
                })
                .slice(0, 3);
            }
    
            function renderShelf(shelf, products, currentVariant, remainingCents, currency) {
              if (!(shelf instanceof HTMLElement) || !products.length) {
                removeShelf();
                return;
              }
    
              const currentVariantId = Number(currentVariant?.id || 0);
              const remainingLabel = formatMoney(remainingCents, currency);
    
              shelf.hidden = false;
              shelf.innerHTML = `
                <div class="yc-pdp-addon-shelf__header">
                  <p class="yc-pdp-addon-shelf__title">Complete free shipping with a small forest piece</p>
                  <p class="yc-pdp-addon-shelf__note">This item is <strong class="yc-pdp-addon-shelf__gap">${escapeHtml(remainingLabel)}</strong> away. Add one small piece with it now.</p>
                </div>
                <div class="yc-pdp-addon-shelf__list">
                  ${products
                    .map(function (product) {
                      const imageMarkup = product.image
                        ? `<img class="yc-pdp-addon-shelf__image" src="${escapeHtml(product.image)}" alt="${escapeHtml(product.title)}" loading="lazy">`
                        : '<div class="yc-pdp-addon-shelf__image" aria-hidden="true"></div>';
    
                      return `
                        <article class="yc-pdp-addon-shelf__card">
                          <a href="${escapeHtml(product.url)}" tabindex="-1" aria-hidden="true">${imageMarkup}</a>
                          <span class="yc-pdp-addon-shelf__copy">
                            <a class="yc-pdp-addon-shelf__name" href="${escapeHtml(product.url)}">${escapeHtml(product.label)}</a>
                            <span class="yc-pdp-addon-shelf__meta">${escapeHtml(formatMoney(product.priceCents, currency))} · ${escapeHtml(product.note)}</span>
                          </span>
                          <button class="yc-pdp-addon-shelf__add" type="button" data-yc-pdp-addon-add data-current-variant-id="${currentVariantId}" data-addon-variant-id="${product.addonVariantId}">Add pair</button>
                        </article>
                      `;
                    })
                    .join('')}
                </div>
              `;
    
              bindShelfButtons(shelf);
            }
    
            function getCartSectionIds() {
              return Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
                .map(function (node) {
                  return node.dataset.sectionId;
                })
                .filter(Boolean);
            }
    
            function isVisibleElement(element) {
              if (!(element instanceof HTMLElement)) return false;
              if (element.hidden || element.getAttribute('aria-hidden') === 'true') return false;
    
              const style = window.getComputedStyle(element);
              if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') return false;
    
              return element.getClientRects().length > 0;
            }
    
            function openCartDrawer() {
              function clickLiveTrigger() {
                const trigger = Array.from(document.querySelectorAll('[data-testid="cart-drawer-trigger"]')).find(isVisibleElement);
                if (trigger instanceof HTMLElement) {
                  trigger.click();
                  return true;
                }
                return false;
              }
    
              async function openOnce() {
                let drawerComponent = document.querySelector('cart-drawer-component');
                if (drawerComponent && typeof drawerComponent.open === 'function') {
                  drawerComponent.open();
                  return true;
                }
    
                if (
                  window.customElements &&
                  typeof window.customElements.whenDefined === 'function' &&
                  !window.customElements.get('cart-drawer-component')
                ) {
                  try {
                    await window.customElements.whenDefined('cart-drawer-component');
                  } catch (error) {}
                }
    
                drawerComponent = document.querySelector('cart-drawer-component');
                if (drawerComponent && typeof drawerComponent.open === 'function') {
                  drawerComponent.open();
                  return true;
                }
    
                const dialog = document.querySelector('[data-testid="cart-drawer-dialog"], .cart-drawer__dialog');
                if (dialog instanceof HTMLDialogElement && typeof dialog.showModal === 'function') {
                  if (dialog.open) return true;
                  try {
                    dialog.showModal();
                    return true;
                  } catch (error) {
                    try {
                      dialog.show();
                      return true;
                    } catch (fallbackError) {}
                  }
                }
    
                return clickLiveTrigger();
              }
    
              [80, 320, 720].forEach(function (delay) {
                window.setTimeout(openOnce, delay);
              });
            }
    
            async function addPairToCart(button) {
              const addonVariantId = Number(button?.dataset?.addonVariantId || 0);
              if (!addonVariantId) return;
    
              const product = await getCurrentProduct();
              const currentVariant = getCurrentVariant(product);
              const currentVariantId = Number(currentVariant?.id || button?.dataset?.currentVariantId || 0);
              if (!currentVariantId) return;
    
              const originalText = button.textContent;
              const quantity = getCurrentQuantity();
              button.disabled = true;
              button.textContent = 'Adding';
    
              try {
                const sectionIds = getCartSectionIds();
                const endpoint = window.Theme?.routes?.cart_add_url || '/cart/add.js';
                const response = await fetch(endpoint, {
                  method: 'POST',
                  credentials: 'same-origin',
                  headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                  },
                  body: JSON.stringify({
                    items: [
                      { id: currentVariantId, quantity },
                      { id: addonVariantId, quantity: 1, properties: { _yc_upsell_source: 'pdp_free_shipping' } },
                    ],
                    sections: sectionIds.join(','),
                    sections_url: window.location.pathname,
                  }),
                }).then(function (fetchResponse) {
                  return fetchResponse.json();
                });
    
                if (response.status) {
                  throw new Error(response.description || response.message || 'Unable to add');
                }
    
                document.dispatchEvent(
                  new CustomEvent('cart:update', {
                    bubbles: true,
                    detail: {
                      resource: response,
                      sourceId: 'yc-pdp-addon-shelf',
                      data: {
                        source: 'yc-pdp-addon-shelf',
                        sections: response.sections,
                        itemCount: quantity + 1,
                      },
                    },
                  })
                );
    
                trackUpsellAdd('pdp_free_shipping', response);
                window.BWShippingBar?.schedule?.();
                window.YCCartAddon?.schedule?.();
                button.textContent = 'Added';
                openCartDrawer();
              } catch (error) {
                button.textContent = 'Try again';
                window.setTimeout(function () {
                  button.disabled = false;
                  button.textContent = originalText;
                }, 1800);
                return;
              }
    
              window.setTimeout(function () {
                button.disabled = false;
                button.textContent = originalText;
              }, 1600);
            }
    
            function bindShelfButtons(root) {
              root.querySelectorAll('[data-yc-pdp-addon-add]').forEach(function (button) {
                if (!(button instanceof HTMLButtonElement) || button.dataset.ycPdpAddonBound === '1') return;
                button.dataset.ycPdpAddonBound = '1';
                button.addEventListener('click', function () {
                  addPairToCart(button);
                });
              });
            }
    
            async function refreshShelf() {
              if (refreshInFlight) return refreshInFlight;
    
              refreshInFlight = (async function () {
                try {
                  const product = await getCurrentProduct();
                  const currentVariant = getCurrentVariant(product);
                  if (!product || !currentVariant) {
                    removeShelf();
                    return;
                  }
    
                  if (currentVariant.priceCents >= thresholdCents) {
                    removeShelf();
                    return;
                  }
    
                  const remainingCents = thresholdCents - currentVariant.priceCents;
                  const shelf = ensureShelf();
                  if (!(shelf instanceof HTMLElement)) return;
    
                  const products = await getVisibleProducts(product.handle, remainingCents);
                  renderShelf(shelf, products, currentVariant, remainingCents, product.currency);
                } catch (error) {
                  removeShelf();
                } finally {
                  refreshInFlight = null;
                }
              })();
    
              return refreshInFlight;
            }
    
            function scheduleRefresh() {
              if (refreshScheduled) return;
              refreshScheduled = true;
              window.setTimeout(function () {
                const refreshPromise = refreshShelf();
                if (!refreshPromise || typeof refreshPromise.finally !== 'function') {
                  refreshScheduled = false;
                  return;
                }
    
                refreshPromise.finally(function () {
                  refreshScheduled = false;
                });
              }, 140);
            }
    
            function startWhenReady() {
              scheduleRefresh();
              document.addEventListener('change', function (event) {
                if (event.target instanceof Element && event.target.closest('.product-details')) {
                  scheduleRefresh();
                }
              });
              document.addEventListener('variant:change', scheduleRefresh);
              document.addEventListener('cart:update', scheduleRefresh);
              window.addEventListener('pageshow', scheduleRefresh);
            }
    
            const api = {
              refresh: refreshShelf,
              schedule: scheduleRefresh,
            };
    
            window.YCPdpAddonShelf = api;
    
            if (document.readyState === 'loading') {
              document.addEventListener('DOMContentLoaded', startWhenReady, { once: true });
            } else {
              startWhenReady();
            }
          })();
  } else {
    window.YCPdpAddonShelf = noopApi();
    removeShelves('[data-yc-pdp-addon-shelf]');
  }

  if (enabled(config.enablePdpUpsell, false) && enabled(config.enablePdpSoundPairing, true)) {
    (function initYcSoundPairingShelf() {
            const mainNode = document.querySelector('main[data-template]');
            const templateName = mainNode?.dataset?.template || '';
            if (!templateName.includes('product')) return;
    
            const shelfSelector = '[data-yc-sound-pairing-shelf]';
            const styleId = 'yc-sound-pairing-styles';
            const productFormSelector =
              '.product-details product-form-component:not(.quick-add__product-form-component) form[data-type="add-to-cart-form"]';
            const profiles = {
              pala: {
                handles: ['handmade-pala-cardamom-seed-pod-wooden-handle-shaker-rainforest-rhythm'],
                titlePattern: /pala/i,
                role: 'Soft water texture',
                line: 'Pair soft water texture with a crisp rain accent.',
                products: [
                  {
                    handle: 'handmade-chacha-oleander-seed-pod-wooden-handle-shaker-rainforest-rhythm-instrument',
                    label: 'Chacha rain shaker',
                    role: 'Crisp rain accent',
                    note: 'Adds a bright, rain-like seed pattern beside Pala.',
                  },
                  {
                    handle: 'handmade-juju-seed-pod-wooden-handle-shaker-rainforest-natural-percussion',
                    label: 'Juju ground shaker',
                    role: 'Deep grounding layer',
                    note: 'Gives the soft texture a warmer low rhythm.',
                  },
                ],
              },
              chacha: {
                handles: ['handmade-chacha-oleander-seed-pod-wooden-handle-shaker-rainforest-rhythm-instrument'],
                titlePattern: /chacha/i,
                role: 'Crisp rain accent',
                line: 'Anchor crisp rain texture with soft water and a deeper forest pulse.',
                products: [
                  {
                    handle: 'handmade-pala-cardamom-seed-pod-wooden-handle-shaker-rainforest-rhythm',
                    label: 'Pala water shaker',
                    role: 'Soft water base',
                    note: 'Softens Chacha with a rounded water-like texture.',
                  },
                  {
                    handle: 'handmade-juju-seed-pod-wooden-handle-shaker-rainforest-natural-percussion',
                    label: 'Juju ground shaker',
                    role: 'Deep grounding layer',
                    note: 'Adds a calmer low rhythm under the crisp top layer.',
                  },
                ],
              },
              juju: {
                handles: ['handmade-juju-seed-pod-wooden-handle-shaker-rainforest-natural-percussion'],
                titlePattern: /juju/i,
                role: 'Deep grounding tone',
                line: 'Lift a deep grounding pulse with water texture and light rain.',
                products: [
                  {
                    handle: 'handmade-pala-cardamom-seed-pod-wooden-handle-shaker-rainforest-rhythm',
                    label: 'Pala water shaker',
                    role: 'Soft water texture',
                    note: 'Brings a flowing upper layer to Juju.',
                  },
                  {
                    handle: 'handmade-chacha-oleander-seed-pod-wooden-handle-shaker-rainforest-rhythm-instrument',
                    label: 'Chacha rain shaker',
                    role: 'Crisp rain accent',
                    note: 'Adds bright seed rainfall over the deeper rhythm.',
                  },
                ],
              },
              panji: {
                handles: ['handmade-panji-white-fruit-seed-pod-wooden-handle-shaker-natural-rhythm'],
                titlePattern: /panji/i,
                role: 'Dry woodland rhythm',
                line: 'Round out Panji with water texture and crisp rain detail.',
                products: [
                  {
                    handle: 'handmade-pala-cardamom-seed-pod-wooden-handle-shaker-rainforest-rhythm',
                    label: 'Pala water shaker',
                    role: 'Soft water texture',
                    note: 'Adds a smoother layer to Panji rhythm.',
                  },
                  {
                    handle: 'handmade-chacha-oleander-seed-pod-wooden-handle-shaker-rainforest-rhythm-instrument',
                    label: 'Chacha rain shaker',
                    role: 'Crisp rain accent',
                    note: 'Creates a brighter, rainfall-like counterpoint.',
                  },
                ],
              },
              salin: {
                handles: ['handmade-salin-water-bellwood-seed-shell-hand-bell-natural-rainforest-decor'],
                titlePattern: /salin|water bell/i,
                role: 'Clear water bell',
                line: 'Let the water-bell shimmer sit beside rain texture and a grounded pulse.',
                products: [
                  {
                    handle: 'handmade-chacha-oleander-seed-pod-wooden-handle-shaker-rainforest-rhythm-instrument',
                    label: 'Chacha rain shaker',
                    role: 'Crisp rain accent',
                    note: 'Adds dry seed rainfall beside the bell-like shimmer.',
                  },
                  {
                    handle: 'handmade-juju-seed-pod-wooden-handle-shaker-rainforest-natural-percussion',
                    label: 'Juju ground shaker',
                    role: 'Deep grounding layer',
                    note: 'Gives the clear bell tone a lower ritual base.',
                  },
                ],
              },
            };
    
            const productCache = new Map();
            let currentProductPromise = null;
            let refreshInFlight = null;
            let refreshScheduled = false;
    
            function getProductHandle() {
              const match = window.location.pathname.match(/\/products\/([^/?#]+)/);
              return match ? decodeURIComponent(match[1]) : '';
            }
    
            function getProductForm() {
              const form = document.querySelector(productFormSelector);
              return form instanceof HTMLFormElement ? form : null;
            }
    
            function getCurrentQuantity() {
              const form = getProductForm();
              const input = form?.querySelector('input[name="quantity"], quantity-selector-component input');
              const value = Number(input?.value || 1);
              return Number.isFinite(value) && value > 0 ? Math.max(1, Math.floor(value)) : 1;
            }
    
            function escapeHtml(value) {
              return String(value || '')
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#39;');
            }
    
            function normalizeImage(url) {
              if (!url) return '';
              return String(url).startsWith('//') ? `https:${url}` : String(url);
            }
    
            function formatMoney(cents, currency) {
              const amount = Number(cents || 0) / 100;
    
              try {
                return new Intl.NumberFormat(undefined, {
                  style: 'currency',
                  currency: currency || window.Shopify?.currency?.active || 'USD',
                }).format(amount);
              } catch (error) {
                return `$${amount.toFixed(2)}`;
              }
            }
    
            function ensureStyles() {
              if (document.getElementById(styleId)) return;
    
              const style = document.createElement('style');
              style.id = styleId;
              style.textContent = `
                .yc-sound-pairing {
                  box-sizing: border-box;
                }
    
                .yc-sound-pairing[hidden] {
                  display: none !important;
                }
    
                .yc-sound-pairing[data-yc-sound-pairing-placement="page"] {
                  display: grid;
                  grid-template-columns: minmax(220px, 0.42fr) minmax(0, 1fr);
                  gap: 34px;
                  width: 100%;
                  margin: 0;
                  padding: 54px max(32px, calc((100vw - 1280px) / 2)) 40px;
                  border-block: 1px solid rgba(246, 241, 226, 0.18);
                  background: #55654b;
                  color: #f7f4ea;
                }
    
                .yc-sound-pairing[data-yc-sound-pairing-placement="details"] {
                  width: 100%;
                  margin: 16px 0;
                  padding: 14px 0 16px;
                  border-block: 1px solid rgba(72, 86, 64, 0.16);
                  color: #3f4b39;
                }
    
                .yc-sound-pairing__header {
                  display: grid;
                  gap: 4px;
                  margin-bottom: 12px;
                }
    
                .yc-sound-pairing__eyebrow {
                  margin: 0;
                  color: #7c866e;
                  font-size: 10px;
                  font-weight: 700;
                  letter-spacing: 0;
                  line-height: 1.2;
                  text-transform: uppercase;
                }
    
                .yc-sound-pairing[data-yc-sound-pairing-placement="page"] .yc-sound-pairing__eyebrow {
                  color: #d5dbc5;
                }
    
                .yc-sound-pairing__title {
                  margin: 0;
                  color: #374230;
                  font-size: 16px;
                  font-weight: 700;
                  line-height: 1.25;
                }
    
                .yc-sound-pairing[data-yc-sound-pairing-placement="page"] .yc-sound-pairing__title {
                  color: #fffaf0;
                  font-size: 36px;
                  font-weight: 500;
                  line-height: 1.08;
                }
    
                .yc-sound-pairing__line {
                  margin: 0;
                  color: #65725d;
                  font-size: 13px;
                  line-height: 1.45;
                }
    
                .yc-sound-pairing[data-yc-sound-pairing-placement="page"] .yc-sound-pairing__line {
                  max-width: 360px;
                  color: #e1e7d2;
                  font-size: 16px;
                  line-height: 1.5;
                }
    
                .yc-sound-pairing__list {
                  display: grid;
                  grid-template-columns: repeat(2, minmax(0, 1fr));
                  gap: 10px;
                }
    
                .yc-sound-pairing[data-yc-sound-pairing-placement="page"] .yc-sound-pairing__list {
                  gap: 14px;
                }
    
                .yc-sound-pairing__card {
                  display: grid;
                  grid-template-columns: 72px minmax(0, 1fr);
                  gap: 10px;
                  min-width: 0;
                  padding: 10px;
                  border: 1px solid rgba(72, 86, 64, 0.14);
                  border-radius: 8px;
                  background: #fbfaf6;
                  box-sizing: border-box;
                }
    
                .yc-sound-pairing[data-yc-sound-pairing-placement="page"] .yc-sound-pairing__card {
                  grid-template-columns: 124px minmax(0, 1fr);
                  gap: 14px;
                  padding: 14px;
                  background: #fffdf7;
                }
    
                .yc-sound-pairing__image {
                  width: 72px;
                  height: 86px;
                  border-radius: 7px;
                  background: #eef0e8;
                  object-fit: cover;
                }
    
                .yc-sound-pairing[data-yc-sound-pairing-placement="page"] .yc-sound-pairing__image {
                  width: 124px;
                  height: 146px;
                }
    
                .yc-sound-pairing__copy {
                  display: grid;
                  align-content: start;
                  gap: 5px;
                  min-width: 0;
                }
    
                .yc-sound-pairing__role {
                  display: inline-flex;
                  width: fit-content;
                  max-width: 100%;
                  padding: 3px 7px;
                  border-radius: 999px;
                  background: rgba(85, 101, 75, 0.12);
                  color: #55654b;
                  font-size: 10px;
                  font-weight: 700;
                  line-height: 1.2;
                }
    
                .yc-sound-pairing__name {
                  overflow: hidden;
                  color: #384333;
                  font-size: 13px;
                  font-weight: 700;
                  line-height: 1.25;
                  text-decoration: none;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
    
                .yc-sound-pairing__note,
                .yc-sound-pairing__price {
                  margin: 0;
                  color: #6a7763;
                  font-size: 11px;
                  line-height: 1.35;
                }
    
                .yc-sound-pairing__actions {
                  display: flex;
                  flex-wrap: wrap;
                  gap: 7px;
                  margin-top: 2px;
                }
    
                .yc-sound-pairing__add,
                .yc-sound-pairing__view {
                  min-height: 32px;
                  padding: 0 12px;
                  border-radius: 999px;
                  font-size: 11px;
                  font-weight: 700;
                  line-height: 32px;
                  text-decoration: none;
                  box-sizing: border-box;
                }
    
                .yc-sound-pairing__add {
                  border: 0;
                  background: #55654b;
                  color: #fff;
                  cursor: pointer;
                }
    
                .yc-sound-pairing__add[disabled] {
                  cursor: wait;
                  opacity: 0.7;
                }
    
                .yc-sound-pairing__view {
                  border: 1px solid rgba(85, 101, 75, 0.28);
                  color: #55654b;
                }
    
                @media screen and (max-width: 749px) {
                  .yc-sound-pairing[data-yc-sound-pairing-placement="page"] {
                    grid-template-columns: 1fr;
                    gap: 16px;
                    padding: 34px 16px 28px;
                  }
    
                  .yc-sound-pairing[data-yc-sound-pairing-placement="page"] .yc-sound-pairing__title {
                    font-size: 26px;
                  }
    
                  .yc-sound-pairing[data-yc-sound-pairing-placement="page"] .yc-sound-pairing__line {
                    font-size: 14px;
                  }
    
                  .yc-sound-pairing[data-yc-sound-pairing-placement="page"] .yc-sound-pairing__list {
                    grid-template-columns: 1fr;
                  }
    
                  .yc-sound-pairing[data-yc-sound-pairing-placement="page"] .yc-sound-pairing__card {
                    grid-template-columns: 88px minmax(0, 1fr);
                  }
    
                  .yc-sound-pairing[data-yc-sound-pairing-placement="page"] .yc-sound-pairing__image {
                    width: 88px;
                    height: 104px;
                  }
    
                  .yc-sound-pairing[data-yc-sound-pairing-placement="details"] {
                    margin: 14px 0;
                    padding: 13px 0 14px;
                  }
    
                  .yc-sound-pairing[data-yc-sound-pairing-placement="details"] .yc-sound-pairing__list {
                    display: flex;
                    gap: 9px;
                    overflow-x: auto;
                    padding-bottom: 2px;
                    scroll-snap-type: x proximity;
                    -webkit-overflow-scrolling: touch;
                  }
    
                  .yc-sound-pairing[data-yc-sound-pairing-placement="details"] .yc-sound-pairing__card {
                    flex: 0 0 min(82vw, 300px);
                    scroll-snap-align: start;
                  }
                }
              `;
    
              document.head.appendChild(style);
            }
    
            async function fetchProduct(handle) {
              if (!handle) return null;
              if (productCache.has(handle)) return productCache.get(handle);
    
              const promise = fetch(`/products/${handle}.js`, { credentials: 'same-origin' })
                .then(function (response) {
                  if (!response.ok) throw new Error(`Product fetch failed: ${handle}`);
                  return response.json();
                })
                .then(function (product) {
                  const variants = Array.isArray(product.variants)
                    ? product.variants
                        .filter(function (variant) {
                          return variant && variant.available && Number(variant.price) > 0;
                        })
                        .map(function (variant) {
                          return {
                            id: Number(variant.id),
                            priceCents: Number(variant.price),
                          };
                        })
                        .sort(function (a, b) {
                          return a.priceCents - b.priceCents;
                        })
                    : [];
    
                  if (!variants.length) return null;
    
                  return {
                    handle,
                    title: product.title || handle,
                    url: product.url || `/products/${handle}`,
                    image: normalizeImage(product.featured_image || ''),
                    currency: product.currency || window.Shopify?.currency?.active || 'USD',
                    variants,
                  };
                })
                .catch(function () {
                  return null;
                });
    
              productCache.set(handle, promise);
              return promise;
            }
    
            function getCurrentProduct() {
              if (!currentProductPromise) {
                currentProductPromise = fetchProduct(getProductHandle());
              }
              return currentProductPromise;
            }
    
            function getCurrentVariant(product) {
              const form = getProductForm();
              const formVariantId = Number(form?.querySelector('[name="id"]')?.value || 0);
              const urlVariantId = Number(new URLSearchParams(window.location.search).get('variant') || 0);
              const selectedId = formVariantId || urlVariantId;
    
              return (
                product?.variants?.find(function (variant) {
                  return variant.id === selectedId;
                }) ||
                product?.variants?.[0] ||
                null
              );
            }
    
            function getProfile(product) {
              const handle = product?.handle || getProductHandle();
              const title = product?.title || document.querySelector('.product-details h1')?.textContent || '';
              return (
                Object.values(profiles).find(function (profile) {
                  return profile.handles.includes(handle) || profile.titlePattern.test(title);
                }) || null
              );
            }
    
            async function getPairProducts(profile, currentHandle) {
              if (!profile) return [];
    
              const products = await Promise.all(
                profile.products.map(function (config) {
                  return fetchProduct(config.handle).then(function (product) {
                    const variant = product?.variants?.[0];
                    if (!product || !variant || product.handle === currentHandle) return null;
    
                    return {
                      ...product,
                      label: config.label || product.title,
                      role: config.role || '',
                      note: config.note || '',
                      addonVariantId: variant.id,
                      priceCents: variant.priceCents,
                    };
                  });
                })
              );
    
              return products.filter(Boolean).slice(0, 3);
            }
    
            function cleanupDuplicateShelves(keeper) {
              document.querySelectorAll(shelfSelector).forEach(function (node) {
                if (node !== keeper) node.remove();
              });
            }
    
            function removeShelf() {
              document.querySelectorAll(shelfSelector).forEach(function (node) {
                node.remove();
              });
            }
    
            function findPlacement() {
              const main = document.querySelector('main[data-template]');
              if (main instanceof HTMLElement) {
                const mainChildren = Array.from(main.children).filter(function (child) {
                  return child instanceof HTMLElement;
                });
                const productList = mainChildren.find(function (child) {
                  const text = child.textContent || '';
                  return (
                    child.id.includes('__product_list') ||
                    child.classList.contains('ui-test-product-list') ||
                    /shop the full collection/i.test(text)
                  );
                });
                if (productList instanceof HTMLElement) return { element: productList, position: 'beforebegin', placement: 'page' };
    
                const reviews = mainChildren.find(function (child) {
                  return /customer reviews/i.test(child.textContent || '');
                });
                if (reviews instanceof HTMLElement) return { element: reviews, position: 'beforebegin', placement: 'page' };
    
                const story = mainChildren.find(function (child) {
                  return /story|gproduct/i.test(`${child.id} ${child.className || ''}`);
                });
                if (story instanceof HTMLElement) return { element: story, position: 'afterend', placement: 'page' };
              }
    
              const details = document.querySelector('.product-details');
              if (!(details instanceof HTMLElement)) return null;
    
              const directChildren = Array.from(details.children).filter(function (child) {
                return child instanceof HTMLElement;
              });
              const accordion = directChildren.find(function (child) {
                return child.matches('.accordion');
              });
              if (accordion instanceof HTMLElement) return { element: accordion, position: 'beforebegin', placement: 'details' };
    
              const description = details.querySelector('[class*="text-block--product_description"]');
              if (description instanceof HTMLElement) return { element: description, position: 'beforebegin', placement: 'details' };
    
              const paymentIcons =
                directChildren.find(function (child) {
                  return child.classList.contains('payment-icons');
                }) || details.querySelector('.payment-icons');
              if (paymentIcons instanceof HTMLElement) return { element: paymentIcons, position: 'afterend', placement: 'details' };
    
              return null;
            }
    
            function ensureShelf() {
              const placement = findPlacement();
              if (!placement) return null;
    
              ensureStyles();
    
              let shelf = document.querySelector(shelfSelector);
              if (!(shelf instanceof HTMLElement)) {
                shelf = document.createElement('section');
                shelf.className = 'yc-sound-pairing';
                shelf.dataset.ycSoundPairingShelf = '';
                shelf.setAttribute('aria-label', 'Complete the ritual sound pairing');
              }
              shelf.dataset.ycSoundPairingPlacement = placement.placement || 'details';
    
              if (placement.position === 'beforebegin') {
                if (placement.element.previousElementSibling !== shelf) {
                  placement.element.insertAdjacentElement('beforebegin', shelf);
                }
              } else if (placement.element.nextElementSibling !== shelf) {
                placement.element.insertAdjacentElement('afterend', shelf);
              }
    
              cleanupDuplicateShelves(shelf);
              return shelf;
            }
    
            function renderShelf(shelf, profile, products, currentVariant, currency) {
              if (!(shelf instanceof HTMLElement) || !profile || !products.length) {
                removeShelf();
                return;
              }
    
              const currentVariantId = Number(currentVariant?.id || 0);
              shelf.hidden = false;
              shelf.innerHTML = `
                <div class="yc-sound-pairing__header">
                  <p class="yc-sound-pairing__eyebrow">Complete the ritual</p>
                  <p class="yc-sound-pairing__title">${escapeHtml(profile.role)}</p>
                  <p class="yc-sound-pairing__line">${escapeHtml(profile.line)}</p>
                </div>
                <div class="yc-sound-pairing__list">
                  ${products
                    .map(function (product) {
                      const imageMarkup = product.image
                        ? `<img class="yc-sound-pairing__image" src="${escapeHtml(product.image)}" alt="${escapeHtml(product.title)}" loading="lazy">`
                        : '<div class="yc-sound-pairing__image" aria-hidden="true"></div>';
    
                      return `
                        <article class="yc-sound-pairing__card">
                          <a href="${escapeHtml(product.url)}" tabindex="-1" aria-hidden="true">${imageMarkup}</a>
                          <div class="yc-sound-pairing__copy">
                            <span class="yc-sound-pairing__role">${escapeHtml(product.role)}</span>
                            <a class="yc-sound-pairing__name" href="${escapeHtml(product.url)}">${escapeHtml(product.label)}</a>
                            <p class="yc-sound-pairing__note">${escapeHtml(product.note)}</p>
                            <p class="yc-sound-pairing__price">${escapeHtml(formatMoney(product.priceCents, currency))}</p>
                            <div class="yc-sound-pairing__actions">
                              <button class="yc-sound-pairing__add" type="button" data-yc-sound-pairing-add data-current-variant-id="${currentVariantId}" data-addon-variant-id="${product.addonVariantId}">Add ritual</button>
                              <a class="yc-sound-pairing__view" href="${escapeHtml(product.url)}">View</a>
                            </div>
                          </div>
                        </article>
                      `;
                    })
                    .join('')}
                </div>
              `;
    
              bindShelfButtons(shelf);
            }
    
            function getCartSectionIds() {
              return Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
                .map(function (node) {
                  return node.dataset.sectionId;
                })
                .filter(Boolean);
            }
    
            function isVisibleElement(element) {
              if (!(element instanceof HTMLElement)) return false;
              if (element.hidden || element.getAttribute('aria-hidden') === 'true') return false;
    
              const style = window.getComputedStyle(element);
              if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') return false;
    
              return element.getClientRects().length > 0;
            }
    
            function openCartDrawer() {
              function clickLiveTrigger() {
                const trigger = Array.from(document.querySelectorAll('[data-testid="cart-drawer-trigger"]')).find(isVisibleElement);
                if (trigger instanceof HTMLElement) {
                  trigger.click();
                  return true;
                }
                return false;
              }
    
              async function openOnce() {
                let drawerComponent = document.querySelector('cart-drawer-component');
                if (drawerComponent && typeof drawerComponent.open === 'function') {
                  drawerComponent.open();
                  return true;
                }
    
                if (
                  window.customElements &&
                  typeof window.customElements.whenDefined === 'function' &&
                  !window.customElements.get('cart-drawer-component')
                ) {
                  try {
                    await window.customElements.whenDefined('cart-drawer-component');
                  } catch (error) {}
                }
    
                drawerComponent = document.querySelector('cart-drawer-component');
                if (drawerComponent && typeof drawerComponent.open === 'function') {
                  drawerComponent.open();
                  return true;
                }
    
                const dialog = document.querySelector('[data-testid="cart-drawer-dialog"], .cart-drawer__dialog');
                if (dialog instanceof HTMLDialogElement && typeof dialog.showModal === 'function') {
                  if (dialog.open) return true;
                  try {
                    dialog.showModal();
                    return true;
                  } catch (error) {
                    try {
                      dialog.show();
                      return true;
                    } catch (fallbackError) {}
                  }
                }
    
                return clickLiveTrigger();
              }
    
              [80, 320, 720].forEach(function (delay) {
                window.setTimeout(openOnce, delay);
              });
            }
    
            async function addPairToCart(button) {
              const addonVariantId = Number(button?.dataset?.addonVariantId || 0);
              if (!addonVariantId) return;
    
              const product = await getCurrentProduct();
              const currentVariant = getCurrentVariant(product);
              const currentVariantId = Number(currentVariant?.id || button?.dataset?.currentVariantId || 0);
              if (!currentVariantId) return;
    
              const originalText = button.textContent;
              const quantity = getCurrentQuantity();
              button.disabled = true;
              button.textContent = 'Adding';
    
              try {
                const sectionIds = getCartSectionIds();
                const endpoint = window.Theme?.routes?.cart_add_url || '/cart/add.js';
                const response = await fetch(endpoint, {
                  method: 'POST',
                  credentials: 'same-origin',
                  headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                  },
                  body: JSON.stringify({
                    items: [
                      { id: currentVariantId, quantity },
                      { id: addonVariantId, quantity: 1, properties: { _yc_upsell_source: 'sound_pairing' } },
                    ],
                    sections: sectionIds.join(','),
                    sections_url: window.location.pathname,
                  }),
                }).then(function (fetchResponse) {
                  return fetchResponse.json();
                });
    
                if (response.status) {
                  throw new Error(response.description || response.message || 'Unable to add');
                }
    
                document.dispatchEvent(
                  new CustomEvent('cart:update', {
                    bubbles: true,
                    detail: {
                      resource: response,
                      sourceId: 'yc-sound-pairing-shelf',
                      data: {
                        source: 'yc-sound-pairing-shelf',
                        sections: response.sections,
                        itemCount: quantity + 1,
                      },
                    },
                  })
                );
    
                trackUpsellAdd('sound_pairing', response);
                window.BWShippingBar?.schedule?.();
                window.YCCartAddon?.schedule?.();
                button.textContent = 'Added';
                openCartDrawer();
              } catch (error) {
                button.textContent = 'Try again';
                window.setTimeout(function () {
                  button.disabled = false;
                  button.textContent = originalText;
                }, 1800);
                return;
              }
    
              window.setTimeout(function () {
                button.disabled = false;
                button.textContent = originalText;
              }, 1600);
            }
    
            function bindShelfButtons(root) {
              root.querySelectorAll('[data-yc-sound-pairing-add]').forEach(function (button) {
                if (!(button instanceof HTMLButtonElement) || button.dataset.ycSoundPairingBound === '1') return;
                button.dataset.ycSoundPairingBound = '1';
                button.addEventListener('click', function () {
                  addPairToCart(button);
                });
              });
            }
    
            async function refreshShelf() {
              if (refreshInFlight) return refreshInFlight;
    
              refreshInFlight = (async function () {
                try {
                  const product = await getCurrentProduct();
                  const currentVariant = getCurrentVariant(product);
                  const profile = getProfile(product);
                  if (!product || !currentVariant || !profile) {
                    removeShelf();
                    return;
                  }
    
                  const shelf = ensureShelf();
                  if (!(shelf instanceof HTMLElement)) return;
    
                  const products = await getPairProducts(profile, product.handle);
                  renderShelf(shelf, profile, products, currentVariant, product.currency);
                } catch (error) {
                  removeShelf();
                } finally {
                  refreshInFlight = null;
                }
              })();
    
              return refreshInFlight;
            }
    
            function scheduleRefresh() {
              if (refreshScheduled) return;
              refreshScheduled = true;
              window.setTimeout(function () {
                const refreshPromise = refreshShelf();
                if (!refreshPromise || typeof refreshPromise.finally !== 'function') {
                  refreshScheduled = false;
                  return;
                }
    
                refreshPromise.finally(function () {
                  refreshScheduled = false;
                });
              }, 160);
            }
    
            function startWhenReady() {
              scheduleRefresh();
              document.addEventListener('change', function (event) {
                if (event.target instanceof Element && event.target.closest('.product-details')) {
                  scheduleRefresh();
                }
              });
              document.addEventListener('variant:change', scheduleRefresh);
              document.addEventListener('shopify:section:load', scheduleRefresh);
              window.addEventListener('pageshow', scheduleRefresh);
            }
    
            const api = {
              refresh: refreshShelf,
              schedule: scheduleRefresh,
            };
    
            window.YCSoundPairingShelf = api;
    
            if (document.readyState === 'loading') {
              document.addEventListener('DOMContentLoaded', startWhenReady, { once: true });
            } else {
              startWhenReady();
            }
          })();
  } else {
    window.YCSoundPairingShelf = noopApi();
    removeShelves('[data-yc-sound-pairing-shelf]');
  }

  window.YCUpsell = {
    refreshCart: function () {
      return window.YCCartAddon?.refresh?.();
    },
    refreshProduct: function () {
      const results = [];
      if (window.YCPdpAddonShelf?.refresh) results.push(window.YCPdpAddonShelf.refresh());
      if (window.YCSoundPairingShelf?.refresh) results.push(window.YCSoundPairingShelf.refresh());
      return Promise.allSettled(results);
    },
    refreshAll: function () {
      const results = [];
      if (window.YCCartAddon?.refresh) results.push(window.YCCartAddon.refresh());
      if (window.YCPdpAddonShelf?.refresh) results.push(window.YCPdpAddonShelf.refresh());
      if (window.YCSoundPairingShelf?.refresh) results.push(window.YCSoundPairingShelf.refresh());
      return Promise.allSettled(results);
    },
  };
})();
